/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import {
  Container,
  Row,
} from "shards-react";

import PageTitle from "../components/common/PageTitle";


class WelcomePage extends React.Component {
  constructor(props) {
    super(props);
  }


  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title="Úvod" subtitle="Vítejte"
                     className="text-sm-left"/>
        </Row>

        <div style={{maxWidth: '50%'}}>
        Vítejte na hernizona.online. Portál Herní zóna přešel pod správu studia <strong>Iron Quest</strong>. Nadále se staráme o zachování oblíbených her, jako je Slovní Fotbal, Kris Kros nebo Dobyvatel. Hry zůstávají zcela zdarma — žádné prémiové účty ani předplatné.
        <br /><br />
        Provoz portálu je financován reklamou, která pokrývá náklady na herní server. Neplánujeme žádné agresivní zpeněžení.
          <br /><br />
          V případě dotazů nás neváhejte <a href={'/info'}>kontaktovat</a>. Rádi zodpovíme Vaše dotazy.
        </div>
      </Container>
    );
  }
}

export default WelcomePage;
